<template>
  <div class="list-box">
    <div
      class="nav gap-x-3"
      title="GongYingShangList"
      data-title="采购付款申请"
    >
      <el-segmented
        v-model="state.params.status"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[{ Text: '全部' }, ...$base.Supplier_PaymentApply_Status]"
        class="c-segmented"
        @change="onLoad()"
      />
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
    </div>
    <div class="content c-table-box mt-2 bg-white p-4 rounded-lg">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="状态" label2="单号" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.number">
              <template #top>
                <c_status
                  arrName="Supplier_PaymentApply_Status"
                  :value="row.status"
                  :key="row.status"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="收款信息">
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.supplierBankAccount?.name"
              :value2="
                row.supplierBankAccount?.opening_bank +
                '-' +
                row.supplierBankAccount?.account
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="预付金额"
          :formatter="$tab_MoneyFormat"
        >
          <template #default="{ row }">
            <div class="flex gap-x-3">
              <c_money :value="row.amount" :key="row.amount" />
              <text class="text-gray-400 text-xs">{{
                row.d_payment_type_name
              }}</text>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="intro"
          label="申请说明"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="操作" fixed="right" align="center" :width="120">
          <template #default="{ row }">
            <el-button
              type="success"
              :icon="Search"
              link
              @click="
                state.selectId = row.id;
                state.showDetail = true;
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showDetail"
    title="付款申请详情"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    width="70%"
  >
    <c_detail :id="state.selectId" :supplier_id="props.supplier_id" />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { supplier_purchase_payment_apply_page } from "@/http/supplier";

import c_detail from "./Detail.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    supplier_id: Number,
  },
  components: {
    c_detail,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.supplier_id = props.supplier_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      supplier_purchase_payment_apply_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    return { state, props, onLoad };
  },
};
</script>

<style lang="scss" scoped></style>
